import ViewFileModal from "@/components/ViewFileModal";
import { useState } from "react";
import { Edit2 } from "lucide-react";
import { Button } from "@chakra-ui/react";

export type PortfolioImage = {
	name: string;
	type: string;
	urls: {
		originalUrl: string;
		thumbnailUrl: string;
	};
	itemId?: string;
	itemType?: "project-history-item" | "employment-history-item";
};

type Props = {
	image: PortfolioImage;
	onEdit?: (
		itemId: string,
		itemType: "project-history-item" | "employment-history-item"
	) => void;
};

export default function PortfolioImageContainer({
	image: {
		name,
		type,
		urls: { originalUrl, thumbnailUrl },
		itemId,
		itemType,
	},
	onEdit,
}: Props) {
	const [isOpen, setIsOpen] = useState(false);

	const handleEdit = (e: React.MouseEvent) => {
		e.stopPropagation(); // Prevent opening the view modal
		if (onEdit && itemId && itemType) {
			onEdit(itemId, itemType);
		}
	};

	return (
		<div className="relative w-full flex justify-center items-center">
			<ViewFileModal
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				file={{ name, url: originalUrl, type: type.split("/")[1] }}
			/>
			<div
				className="bg-[#F5F5F5] w-fit h-fit p-1 lg:p-2 cursor-pointer"
				onClick={() => setIsOpen(true)}
			>
				<img
					src={thumbnailUrl}
					alt="Work history item"
					className="h-[180px] w-[200px] object-contain"
				/>
				{onEdit && itemId && itemType && (
					<Button
						position="absolute"
						top={2}
						right={{
							base: 24,
							lg: 7,
						}}
						size="sm"
						colorScheme="brand"
						onClick={handleEdit}
						leftIcon={<Edit2 className="w-3 h-3" />}
						className="opacity-80 hover:opacity-100 transition-opacity"
					>
						Edit
					</Button>
				)}
			</div>
		</div>
	);
}
